export { QRFeedback } from "./qr-feedback";
